import Color from 'color';
import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import CardBackgroundSVG from '../../assets/payments/card-background.svg';
import {getColor, getRem, ms, square} from '../../styles';
import {Image} from '../../uikit/Image';
import {Text} from '../../uikit/Text';
import {View} from '../../uikit/View';

export const Container = styled(View)<StyledProps & {$backgroundColor: string}>`
  border-radius: ${ms(10)};
  background-color: ${p => Color(p.$backgroundColor).darken(0.4).toString()};
  flex-direction: column;
  justify-content: flex-end;
  position: relative;

  ${p => {
    switch (p.variant) {
      case 'small':
        return css`
          width: ${ms(58)};
          height: ${ms(38)};
          padding: ${ms(6)};
        `;
      case 'smallv2':
        return css<{$backgroundColor: string}>`
          width: ${ms(115)};
          height: ${ms(72)};
          flex-direction: row;
          justify-content: center;
          align-items: center;
          column-gap: ${ms(7)};
          background-color: ${p.$backgroundColor};
        `;
      default:
        return css`
          width: ${ms(180)};
          height: ${ms(105)};
          padding: ${ms(12)} ${ms(9)};
        `;
    }
  }}
`;

export const NumberContainer = styled(View)<StyledProps>`
  flex-direction: row;
  align-items: center;

  ${p => {
    switch (p.variant) {
      case 'small':
        return css`
          margin-bottom: 0;
        `;
      case 'smallv2':
        return css``;
      default:
        return css`
          margin-bottom: ${ms(12)};
        `;
    }
  }}
`;

export const DotsGroup = styled(View)`
  flex-direction: row;
  margin-right: ${ms(10)};
`;

export const Dot = styled(View)`
  ${square(3)};
  border-radius: ${ms(3)};
  background-color: ${p =>
    Color(getColor('icon.white')(p)).alpha(0.6).toString()};
  margin-right: ${ms(2)};
`;

const SText = styled(Text)`
  font-size: ${ms(9)};
  line-height: ${ms(13)};
  color: ${getColor('text.white')};
`;

export {SText as Text};

export const CardInfoText = styled(Text).attrs({
  color: 'text2',
  weight: 'semibold',
})`
  font-size: ${getRem(16)};
`;

export const BrandImage = styled(Image)<StyledProps>`
  position: absolute;
  right: ${ms(6)};

  ${p => {
    switch (p.variant) {
      case 'small':
        return css`
          width: ${ms(20)};
          height: ${ms(12)};
          bottom: ${ms(6)};
        `;
      case 'smallv2':
        return css`
          position: unset;
          width: ${ms(45)};
          height: ${ms(32)};
          background-color: ${Color(getColor('background1')(p))
            .alpha(0.5)
            .toString()};
          border-radius: ${ms(4)};
          border: ${ms(0.5)} solid
            ${Color(getColor('background1')(p)).alpha(0.5).toString()};
        `;
      default:
        return css`
          width: ${ms(28)};
          height: ${ms(28)};
          bottom: ${ms(8)};
        `;
    }
  }}
`;

export const CardMediumBackground = styled(CardBackgroundSVG)`
  position: absolute;
  inset: 0;
`;
